import { useApiQuery } from '@/api/main/query'
import { PaginatedCollection } from '@/api/types'
import { FarmModel } from '@/entities/farm/model/types'
import { deviceAPI } from '@/features/devices/api/endpoints'
import { DeviceModel } from '@/features/devices/types/types'
import { farmsAPI } from '@/features/farm/api/endpoints'
import { OptionModel } from '@/shared/lib/types'
import { RootState } from '@/store/store'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

export const useRequisiteOptions = (modalVisible: boolean) => {
  const { banks } = useSelector((state: RootState) => state.banks)
  const [optionsBanks, setOptionsBanks] = useState<OptionModel[]>([])
  const [optionsDevice, setOptionsDevice] = useState<OptionModel[]>([])
  const [optionsFarm, setOptionsFarm] = useState<OptionModel[]>([])

  const { data: devicesData, refetch: refetchDevices } = useApiQuery<
    PaginatedCollection<DeviceModel[]>
  >(
    ['devices'],
    deviceAPI.baseKey,
    { skip: 0, take: 1000 },
    {
      enabled: false,
    }
  )

  const { data: farmsData, refetch: refetchFarms } = useApiQuery<PaginatedCollection<FarmModel[]>>(
    ['farms'],
    farmsAPI.getMany(`1`, `1000`),
    undefined,
    { enabled: false }
  )

  useEffect(() => {
    if (modalVisible) {
      refetchDevices()
      refetchFarms()
    }
  }, [modalVisible, refetchDevices, refetchFarms])

  useEffect(() => {
    if (banks) {
      const bankOptions = banks.map((bank) => ({
        label: bank.name,
        value: bank.id,
      }))
      setOptionsBanks(bankOptions)
    }
  }, [banks])

  useEffect(() => {
    if (devicesData?.items) {
      const deviceOptions = devicesData.items.map((device) => ({
        label: device.name,
        value: device.id,
      }))
      setOptionsDevice(deviceOptions)
    }
  }, [devicesData])

  useEffect(() => {
    if (farmsData?.items) {
      const farmOptions = [
        {
          label: 'Без фермы',
          value: null,
        },
        ...farmsData.items.map((farm) => ({
          label: farm.name ?? '',
          value: farm.id,
        })),
      ]
      setOptionsFarm(farmOptions)
    }
  }, [farmsData])

  return {
    optionsBanks,
    optionsDevice,
    optionsFarm,
  }
}
